import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { inject } from '@angular/core';
import { signalStore } from '@ngrx/signals';
import { PagedResponse, QueryFiltersParams, QueryPagingParams } from 'mbs-ui-shared@models';
import { User } from 'mbs-ui-shared@models/user';
import { UsersService } from 'mbs-ui-shared@services/users/users.service';
import { withPagingAndData } from 'mbs-ui-shared@store/withPagingAndDataStoreFeature/withPagingAndData';
import { Observable } from 'rxjs';

export const UsersStore = signalStore(
  { providedIn: 'root' },
  withDevtools('UsersStore'),
  withPagingAndData<User>({
    selectId: (entity) => entity.id,
    getEntityById: () => {
      const service = inject(UsersService);
      return (id: string): Observable<User> => service.getById(id);
    },
    // No getEntitiesByIds endpoint
    getEntitiesByIds: () => null,
    getEntities: () => {
      const service = inject(UsersService);
      return (params: QueryFiltersParams & QueryPagingParams): Observable<PagedResponse<User>> => service.get(params);
    }
  })
);

export type UsersStore = InstanceType<typeof UsersStore>;
